module.exports = __webpack_public_path__ + "static/media/url.81805207.svg";